import { Button, Modal, Text } from "@alpacahq/ui/old";

import type { AcatsTransfer } from "~/v2/api/rest/acats";

export interface CannotProcessTransferModalProps {
  isOpen: boolean;
  onBack: () => void;
  onConfirm: () => void;
  reason:
    | { type: "account_info" }
    | { type: "ongoing_transfer"; data: AcatsTransfer }
    | null;
}

export const CannotProcessTransferModal = ({
  isOpen,
  onBack,
  onConfirm,
  reason,
}: CannotProcessTransferModalProps) => {
  return (
    <Modal
      title="Cannot Process Portfolio Transfer"
      isOpen={isOpen}
      onClose={onBack}
      controls={
        <div className="flex gap-2">
          <Button variant="v2/stroke" onClick={onBack}>
            Back to Transfer
          </Button>
          <Button variant="v2/filled" onClick={onConfirm}>
            Stay on this page
          </Button>
        </div>
      }
    >
      <div className="flex flex-col gap-4 text-gray-700">
        {reason?.type === "account_info" && (
          <>
            <Text>
              For a successful Portfolio Transfer, please ensure that your full
              name, Tax ID, and account type at your originating brokerage match
              the details registered on your Alpaca account.{" "}
            </Text>
            <Text>
              Should you have further questions, please contact
              <a
                href="mailto:support@alpaca.markets"
                className="text-indigo-500 underline"
              >
                support@alpaca.markets
              </a>
              .
            </Text>
          </>
        )}
        {reason?.type === "ongoing_transfer" && (
          <>
            <Text>
              You have ongoing Portfolio Transfer from the same account:
            </Text>
            <div className="flex flex-col gap-2 rounded bg-cool-grauy-50 p-2">
              <div className="flex items-center justify-between gap-2">
                <Text className="font-medium text-gray-700 text-sm">
                  Broker name
                </Text>
                <Text className="font-bold text-gray-700">
                  {reason.data.contra_broker_name}
                </Text>
              </div>
              <div className="flex items-center justify-between gap-2">
                <Text className="font-medium text-gray-700 text-sm">
                  Account Type
                </Text>
                <Text className="font-bold text-gray-700">
                  {reason.data.account_type}
                </Text>
              </div>
              <div className="flex items-center justify-between gap-2">
                <Text className="font-medium text-gray-700 text-sm">
                  Account Number
                </Text>
                <Text className="font-bold text-gray-700">
                  {reason.data.account_number}
                </Text>
              </div>
              <div className="flex items-center justify-between gap-2">
                <Text className="font-medium text-gray-700 text-sm">
                  Transfer Date
                </Text>
                <Text className="font-bold text-gray-700">
                  {reason.data.created_at}
                </Text>
              </div>
            </div>
            <Text>
              Please wait till the previous transfer to be completed. More
              questions? Contact{" "}
              <a
                href="mailto:support@alpaca.markets"
                className="text-indigo-500 underline"
              >
                support@alpaca.markets
              </a>
              .
            </Text>
          </>
        )}
      </div>
    </Modal>
  );
};
